
import { type FC, type PropsWithChildren } from 'react';

import { IconButton } from '@eneco/sparky';
import { HelpIcon } from '@eneco/sparky/icons';

/** Accessible name when CMS `triggerText` is missing — keep Dutch (WCAG 4.1.2 / 2.4.6). */
export const NAVIGATION_HELP_BUTTON_LABEL = 'Hulp';

interface Props {
  label?: string;
  onClick?: () => void;
}

export const NavigationHelpButton: FC<PropsWithChildren<Props>> = ({ label, onClick }) => (
  <IconButton label={label?.trim() || NAVIGATION_HELP_BUTTON_LABEL} onClick={onClick}>
    <HelpIcon color="iconSecondary" />
  </IconButton>
);
